import { IDs } from '../../helpers/IDs';
import { sortObjectArray } from './sortObjectArray';
import { hasEntityActivatedRfg, hasEntityRfgField } from '../../bereiche/dateneingabe/functions/CustomDatensatzRfg';
import * as config from '../../wips.config.js';

export function sortKomplexDataRows(entity: string, data: Array<any>, globalData: any, jahr_von: number, jahr_bis: number) {
    switch (entity) {
        case IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE:
            return sortDataKraftstoffe(data, globalData, jahr_von, jahr_bis);
        case IDs.ENT_ENERGIEDATEN_EIGENSTROM:
            return sortDataEigenstrom(data);
    }

    // const enableRfg = config.devFeaturesMap && config.devFeaturesMap.N133_DATENSATZ_REIHENFOLGE ? true : false;
    // const hasActivatedRfg = hasEntityActivatedRfg(entity, globalData);

    // WKETOOL-214 - CL566: Die Reihenfolge sollte auch bei deaktivierter Sortierung bleiben.
    const hasRfgField = hasEntityRfgField(entity);
    if (hasRfgField) {
        // Sortierung nach Reihenfolge
        return sortDataRfg(data);
    }
    // Ohne Sortierung
    return data;
}

function sortDataKraftstoffe(data: Array<any>, globalData: any, jahr_von: number, jahr_bis: number) {
    const fahrzeuge = (globalData[IDs.ENT_FAHRZEUGE] || []).filter((f: any) => data.find((d: any) => d.fahrzeug_tid_orig === f.tid));
    // sortiere nach "Fahrzeug / Bezeichnung" + "Kraftstoff"
    const sortByKeys = ['name', 'energiedaten_kraftstoff_energietraeger'];
    sortObjectArray(fahrzeuge, sortByKeys);
    let dataSorted: Array<any> = [];
    fahrzeuge.forEach((f: any) => {
        while (data.find((d: any) => d.fahrzeug_tid_orig === f.tid && d.jahr >= jahr_von && d.jahr <= jahr_bis && !isExtraRow(d._formKey))) {
            for (let j = jahr_von; j <= jahr_bis; j++) {
                const idx = data.findIndex((d: any) => d.fahrzeug_tid_orig === f.tid && d.jahr === j);
                if (idx >= 0) {
                    dataSorted.push(data[idx]);
                    data.splice(idx, 1);
                } else {
                    dataSorted.push({ jahr: j });
                }
            }
        }
    });
    dataSorted = [...dataSorted, ...data];
    // console.log(dataSorted, data, fahrzeuge);
    return dataSorted;
}

function sortDataEigenstrom(data: Array<any>) {
    const dataSorted = [...data];
    const sortByKeys = ['jahr', 'anlagen_eigenstrom_typ_tid', 'abrechnungszeitraum_von', 'abrechnungszeitraum_bis'];
    sortObjectArray(dataSorted, sortByKeys);
    // console.log(data, dataSorted);
    return dataSorted;
}

export function sortDataRfg(data: Array<any>) {
    const dataSorted = [...data];
    dataSorted.forEach((r: any) => {
        // Fehlende rfg mit tid füllen
        if (!r.rfg) {
            r.rfg = r.tid;
        }
    });
    const sortByKeys = ['rfg'];
    sortObjectArray(dataSorted, sortByKeys);
    return dataSorted;
}

function isExtraRow(formKey: string) {
    if (!formKey) {
        return false;
    }
    const keyArr = formKey.split('_');
    const len = keyArr.length;
    if (len === 0) {
        return false;
    }
    return keyArr[len - 2] === 'X';
}
